import { render, staticRenderFns } from "./tuihuosq.vue?vue&type=template&id=623169f8&scoped=true"
import script from "./tuihuosq.vue?vue&type=script&lang=js"
export * from "./tuihuosq.vue?vue&type=script&lang=js"
import style0 from "./tuihuosq.vue?vue&type=style&index=0&id=623169f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623169f8",
  null
  
)

export default component.exports